import { GatewayURL, AuthBaseURL, TaskURL, AttachURL, CrudURL, SupportURL, DataAsServiceURL, BIMURL, ZATURL, LogURL, SterloLogURL } from './config';
import axios from "axios";
import { glbScreenLoader as setLoading } from "../Helpers/GlobalFunctions";
import { CallConfirmDialog, fnGetDirectBulkData, glbAssignLanguageProperty, glbGetLocalStorage, glbGetSessionStorage, glbSetLocalStorage, glbSetSessionStorage, glEncrypt, glDecrypt, glbScreenLoader as setisLoading } from '../Helpers/GlobalFunctions';
import { ReactSession } from 'react-client-session';
/*
PROPS - toa - type of access : 
    g - global(auth),
    o - design(crud),
    t - task(wfp),
    d - data(crud),
    u - universal(auth)
    a - attach(att)
        method - methodname(get/post)
        lookup - function reference 
        projid  - project id - OPTIONAL
        params - parameters
        appid   -  OPTIONAL 

*/

export const CallApi = async (props) => {
    let lscurrentdate = '';
    let lsexpires = '';
    let lslookupparam = '';
    let lsRefreshToken = "";
    let lsAccessToken = "";
    let lologoutmsg = {};
    try {
        let lbislogout = glbGetLocalStorage("islogout");
        if (glbGetLocalStorage("logoutissue") && window.location.pathname.includes("/logout") && lbislogout) {
            return;
        }
        let lsMethod = props.method;
        let lsLookup = props.lookup;
        let lsParams = props.params;
        let lsBody = props.body;
        let lsToa = props.toa;
        let lsTca = props.tca;
        let lsDomain = props.dn
        let lsProjId = props.actproj;
        let lsAppID = props.actapp;
        let lsCacheType = props.cachetype;
        let lbRefreshCache = props.refreshcache;
        let lsDataSource = props.datasource;
        let lbIsDesign = props.isdesign;
        let lbSkpDS = (props.skpds === undefined || props.skpds === null) ? false : props.skpds;
        let lbSCache = (props.scache === undefined || props.scache === null) ? false : props.scache;
        let loDataSource = [];
        if (lsDataSource !== undefined && lsDataSource !== null && lsDataSource !== "") {
            try {
                if (typeof lsDataSource === "string") {
                    loDataSource = JSON.parse(lsDataSource);
                }
                else {
                    loDataSource = props.datasource;
                }
                // console.log(loDataSource);
                let loReturnData = { status: true, data: [], error: "", errmsg: "", info: "" }
                if (loDataSource.islocalcache === "Yes" || loDataSource.islocalcache === "yes") {
                    lsCacheType = "L";
                }
                if (loDataSource.type === "App") {
                    lsMethod = "get";
                    lsLookup = "dpcrud/rt";
                    if (loDataSource.hasOwnProperty("toa")) {
                        lsToa = loDataSource.toa;
                    }
                    if (lsToa === "" || lsToa === undefined) {
                        lsToa = "o";
                    }
                    if (loDataSource.lookup === "" || loDataSource.lookup === undefined || loDataSource.lookup === null) {
                        loDataSource.lookup = -1;
                    }
                    let loparams = {};
                    try {
                        if (typeof loDataSource.params === "object") {
                            if (loDataSource.params.length > 0) {
                                for (let i = 0; i < loDataSource.params.length; i++) {
                                    if (Object.keys(loDataSource.params[i]).length > 1) {
                                        let lsSource = loDataSource.params[i][Object.keys(loDataSource.params[i])[0]];
                                        let lsInputPara = Object.keys(loDataSource.params[i])[1];
                                        if (loDataSource.params[i].hasOwnProperty("pname")) {
                                            lsSource = loDataSource.params[i].source;
                                            lsInputPara = loDataSource.params[i].pname;
                                        }
                                        if (lsSource !== null && lsSource !== undefined) {
                                            lsSource = lsSource.toLowerCase();
                                        }
                                        let lsValue = "";
                                        if (lsSource === "direct") {
                                            lsValue = loDataSource.params[i][lsInputPara];
                                            if (loDataSource.params[i].hasOwnProperty("value")) {
                                                lsValue = loDataSource.params[i].value;
                                            }
                                        }
                                        else if (lsSource === "pv") {
                                            if (lbIsDesign === true) {
                                                // if (loDataSource.params[i].hasOwnProperty("defvalue")) {
                                                //     lsValue = loDataSource.params[i].defvalue;
                                                // }
                                            }
                                            else {
                                                if (typeof loDataSource.pvinfo === "object") {
                                                    let lopvinfo = loDataSource.pvinfo;
                                                    let lofilterpvinfo = lopvinfo.filter(function (item) { return item.id === loDataSource.params[i].value });
                                                    if (lofilterpvinfo.length > 0) {
                                                        lsValue = lofilterpvinfo[0].value;
                                                    }
                                                }
                                            }
                                            if (lsValue === "" || lsValue === undefined || lsValue === null) {
                                                if (loDataSource.params[i].defvalue !== "" && loDataSource.params[i].defvalue !== undefined && loDataSource.params[i].defvalue !== null) {
                                                    if (typeof loDataSource.params[i].defvalue === "string" && loDataSource.params[i].defvalue.includes("session")) {
                                                        let lssourcelink = JSON.parse(loDataSource.params[i].defvalue);
                                                        if (lssourcelink.hasOwnProperty("session")) {
                                                            lsValue = glbGetLocalStorage(lssourcelink.session);
                                                        }
                                                    }
                                                    else {
                                                        lsValue = loDataSource.params[i].defvalue;
                                                    }
                                                }
                                            }
                                        }
                                        else if (lsSource === "av") {

                                        }
                                        else if (lsSource === "formula") {
                                            if (loDataSource.params[i].hasOwnProperty("value")) {
                                                lsValue = loDataSource.params[i].value;
                                            }
                                            if (typeof lsValue === "string" && lsValue.includes("session")) {
                                                let lssourcelink = JSON.parse(lsValue);
                                                if (lssourcelink.hasOwnProperty("session")) {
                                                    lsValue = glbGetLocalStorage(lssourcelink.session);
                                                }
                                            }
                                        }
                                        if (lsValue === null || lsValue === undefined) {
                                            lsValue = "";
                                        }
                                        loparams[lsInputPara] = lsValue;
                                    }
                                }
                            }
                            else {
                                loparams = loDataSource.params;
                            }
                        }
                    }
                    catch (err) {
                        console.log(err);
                    }
                    lsParams = { id: loDataSource.dataset, ver: -1, alias: loDataSource.lookup, lparams: loparams };
                    if (!(loDataSource.dataset > 0)) {
                        console.log(lsParams);
                        loReturnData.data = [];
                        loReturnData.errmsg = "Dataset id not defined";
                        loReturnData.status = false;
                        return loReturnData;
                    }
                }
                else if (loDataSource.type === "Direct") {
                    if (loDataSource.dataref > 0) {
                        let lodata = await fnGetDirectBulkData(loDataSource.dataref);
                        loReturnData.data = lodata;
                    }
                    else {
                        loReturnData.data = loDataSource.directdata;
                    }
                    loReturnData.data = await glbAssignLanguageProperty(loReturnData.data);
                    return loReturnData;
                }
                else if (loDataSource.type === "TS") {
                    if (loDataSource.thisds === true && typeof loDataSource.linksrcdata === "object") {
                        loReturnData.data = loDataSource.linksrcdata.data;
                    }
                    else {
                        loReturnData.data = [];
                    }
                    return loReturnData;
                }
                else if (loDataSource.type === "GM") {
                    lsMethod = "get";
                    lsLookup = "dpcrud/rt";
                    lsParams = { id: 44, ver: -1, alias: "D001", lparams: { "PsDatasetCode": loDataSource.gencode } };
                    lsToa = "o";
                    lsCacheType = "L";
                }
            }
            catch (err) {

            }
        }
        if (lsLookup === "dpcrud/rt" && typeof lsParams === "object" && !(lsParams.id > 0)) {
            return { status: false, data: [] };
        }
        lsRefreshToken = glbGetLocalStorage("refreshtoken");
        lsAccessToken = glbGetLocalStorage("accesstoken");
        let lsForceLog = glbGetLocalStorage("forcelog");
        let lsLogKey = glbGetLocalStorage("logkey");
        lsexpires = glbGetLocalStorage("expires");
        if (lsProjId === undefined) lsProjId = "";
        if (lsAppID === undefined) lsAppID = "";
        let lsGatewayURL = GatewayURL;
        let lsAuthURL = AuthBaseURL;
        let lsTaskURL = TaskURL;
        let lsAttachURL = AttachURL;
        let lsCrudURL = CrudURL;
        let lsSupportURL = SupportURL;
        let lsDataAsServiceURL = DataAsServiceURL;
        let lsBIMURL = BIMURL;
        let lsZATURL = ZATURL;
        let lsLogURL = LogURL;
        let lsSterloLogURL = SterloLogURL;
        // if (window.location.host === "52.140.120.27:81" || window.location.host === "dev-equaliser.lntecc.com") {
        //     lsGatewayURL = "http://52.140.120.27:82/";
        // }
        // lsGatewayURL = "http://52.140.120.27:82/";
        let loconfig = glbGetLocalStorage("config");
        if (loconfig !== undefined && loconfig !== null) {
            if (loconfig.hasOwnProperty("gatewayurl")) {
                lsGatewayURL = loconfig.gatewayurl;
            }
            if (loconfig.hasOwnProperty("authbaseurl")) {
                lsAuthURL = loconfig.authbaseurl;
            }
            if (loconfig.hasOwnProperty("taskurl")) {
                lsTaskURL = loconfig.taskurl;
            }
            if (loconfig.hasOwnProperty("attachurl")) {
                lsAttachURL = loconfig.attachurl;
            }
            if (loconfig.hasOwnProperty("crudurl")) {
                lsCrudURL = loconfig.crudurl;
            }
            if (loconfig.hasOwnProperty("supporturl")) {
                lsSupportURL = loconfig.supporturl;
            }
            if (loconfig.hasOwnProperty("dasurl")) {
                lsDataAsServiceURL = loconfig.dasurl;
            }
            if (loconfig.hasOwnProperty("bimurl")) {
                lsBIMURL = loconfig.bimurl;
            }
        }
        let lstempcache = glbGetLocalStorage("cachetype");
        if (lstempcache === "L") {
            lsCacheType = lstempcache;
        }
        lscurrentdate = new Date(new Date().getTime() + 10 * 60000);
        if (lsLookup !== "Authentication/ValidateOTP" && lscurrentdate > new Date(lsexpires)) {
            // console.log("Expired Access Token");
            // console.log(locurrentTenant);
            let loRefreshTokenHeader = { "Content-Type": "application/json", "Authorization": "Bearer " + lsAccessToken, "toa": "g", "RefreshToken": lsRefreshToken };
            let loconfig = glbGetLocalStorage("config");
            if (loconfig !== undefined && loconfig !== null) {
                if (loconfig.hasOwnProperty("langpref") && loconfig["langpref"] === true) {
                } else {
                    loRefreshTokenHeader.skpencypt = true;
                    loRefreshTokenHeader.skpdecypt = true;
                }
            }
            const tknresponse = await axios.post(lsGatewayURL + lsAuthURL + "Authentication/TenantRefresh", "", { headers: loRefreshTokenHeader })
            if (tknresponse.status === true || tknresponse.status === 200) {
                if (loconfig.hasOwnProperty("langpref") && loconfig["langpref"] === true) {
                    let decryptedData = glDecrypt(tknresponse.data).toString();
                    if (decryptedData !== null && decryptedData !== "") {
                        try {
                            decryptedData = JSON.parse(decryptedData);
                        }
                        catch (error) {
                        }
                    }
                    tknresponse.data = decryptedData;
                }
                if (tknresponse.data.status === true || tknresponse.data.status === 200) {
                    let lorefreshtoken = JSON.parse(atob(tknresponse.data.data));
                    lsAccessToken = lorefreshtoken.AccessToken;
                    lsLogKey = lorefreshtoken.LogToken;
                    lsexpires = lorefreshtoken.Expires
                    glbSetLocalStorage("accesstoken", lorefreshtoken.AccessToken);
                    glbSetLocalStorage("logkey", lorefreshtoken.LogToken);
                    glbSetLocalStorage("expires", lorefreshtoken.Expires);
                }
            }
        }
        let lnappslno = glbGetLocalStorage("appslno");
        if (!(lnappslno > 0)) {
            let lndesignappslno = glbGetLocalStorage("designappslno");
            if (lndesignappslno > 0) {
                lnappslno = lndesignappslno;
            }
        }
        let lstlydesgnreqd = glbGetLocalStorage("tlydesgnreqd");
        let loHeader = {
            "X-Content-Type-Options": "nosniff",
            "X-Frame-Options": "deny",
            "Content-Security-Policy": "script-src 'self'; style-src 'self'; ...",
            "Strict-Transport-Security": "max-age=63072000; includeSubDomains",
            "Content-Type": "application/json",
            "Authorization": "Bearer " + lsAccessToken,
            "toa": lsToa, "logkey": lsLogKey,
            "forcelog": lsForceLog,
            "actproj": glbGetLocalStorage("projslno"),
            "actapp": lnappslno,
            "tca": lstlydesgnreqd === "Y" ? lstlydesgnreqd : "N"
        };
        if (typeof props.header === "object" && props.header !== null) {
            let lheader = Object.keys(props.header);
            lheader.forEach((item) => {
                loHeader[item] = props.header[item];
            })
        }
        if (lsTca !== undefined && lsTca !== "" && lsTca != null) {
            loHeader.tca = lsTca;
        }
        if (lsToa === "r") {//refresh token
            lsToa = "g";
            loHeader.toa = "g";
            loHeader.refreshtoken = lsRefreshToken;
        }
        if (lsToa === "gs") {
            loHeader.toa = "g";
            loHeader.refreshtoken = lsRefreshToken;
        }
        if (lsToa === "ds") {
            loHeader.toa = "d";
        }
        lslookupparam = lsLookup;
        let lsRedirectURL = '';
        switch (lsToa) {
            case 'g':
                lsRedirectURL = lsAuthURL;
                break;
            case 't':
                lsRedirectURL = lsTaskURL;
                break;
            case 'd':
            case 'o':
            case 'u':
            case 'c':
                lsRedirectURL = lsCrudURL;
                break;
            case 'a':
                lsRedirectURL = lsAttachURL;
                break;
            // case 'u':
            //     lsRedirectURL = lsCrudURL;
            //     break;
            case 's':
            case 'gs':
                lsRedirectURL = lsSupportURL;
                break;
            case 'ds':
                lsRedirectURL = lsDataAsServiceURL;
                break;
            case 'bm':
                lsRedirectURL = lsBIMURL;
                break;
            case 'z':
                lsRedirectURL = lsZATURL;
                // zatca url - need to comment below 2 lines for zatca onpremises
                //loHeader.toa = "d";
                //lsGatewayURL = "https://opgw.oreapps.com/";
                break;
            case 'lg':
                lsRedirectURL = lsLogURL;
                break;
            case 'sl':
                lsRedirectURL = lsSterloLogURL;
                break;
            default:
                lsRedirectURL = lsAuthURL;
        }

        if (typeof lsParams === "object") {
            if (lsParams.hasOwnProperty("lparams") && lsParams.lparams !== null && lsParams.lparams !== undefined) {
                lsParams.lparams = JSON.stringify(lsParams.lparams).split(',"').join("~").slice(1, -1).replace(/:/g, "!").replace(/"/g, "");
            }
            else {
                lsParams.lparams = ""
            }
            //let lsformated = JSON.stringify(lsParams).split(',"').join("@").slice(1, -1).replace(/@/g, "=").replace(/"/g, "");
            let lsformated = JSON.stringify(lsParams).split(',"').join("&").slice(1, -1).replace(/:/g, "=").replace(/"/g, "");
            lsformated = lsformated.replace(/!/g, ":");
            lslookupparam += "?" + lsformated;
        }
        else {
            if (lsParams !== "" && lsParams !== undefined) { lslookupparam += "?" + lsParams; }
        }

        let louserdata = glbGetLocalStorage("ssUserData");
        if (louserdata !== undefined && louserdata !== null) {
            if (louserdata.hasOwnProperty("usercode")) {
                if (lsParams != undefined && lsParams != null && lsParams != "") {
                    lslookupparam += "&uscode=" + louserdata['usercode'];
                } else {
                    lslookupparam += "?uscode=" + louserdata['usercode'];
                }
            }
        }

        let loReturnData = { status: false, data: [], error: "", errmsg: "", info: "" }
        if (lsMethod === "post") {

            if (lbSkpDS === true) {
                loHeader.skpencypt = true;
                loHeader.skpdecypt = true;
            } else {

                let loconfig = glbGetLocalStorage("config");
                if (loconfig !== undefined && loconfig !== null) {
                    if (loconfig.hasOwnProperty("langpref") && loconfig["langpref"] === true) {
                        //if (!lslookupparam.includes('Authentication/')) {
                        lsBody = glEncrypt(lsBody).toString();
                        //}
                    } else {
                        loHeader.skpencypt = true;
                        loHeader.skpdecypt = true;
                    }
                }

                if (loconfig !== undefined && loconfig !== null) {
                    if (loconfig.hasOwnProperty("langpref") && loconfig["langpref"] === true) {
                        if (lslookupparam.includes('[') || lslookupparam.includes('{')) {
                            loHeader.skpencypt = true;
                        } else {
                            //if (!lslookupparam.includes('Authentication/')) {
                            let url = lslookupparam.split('?')[0];
                            let params = lslookupparam.split('?')[1];
                            let encryptedParams = glEncrypt(params).toString();
                            lslookupparam = url + '?' + encryptedParams
                            //}
                        }
                    } else {
                        loHeader.skpencypt = true;
                        loHeader.skpdecypt = true;
                    }
                }
            }

            if (lbSCache === true) {
                loHeader.scache = true;
            }

            const postresponse = await axios.post(lsGatewayURL + lsRedirectURL + lslookupparam, lsBody, { headers: loHeader, timeout: 900000 })
            if (postresponse.status === 200) {

                if (lbSkpDS === false) {
                    let loconfig = glbGetLocalStorage("config");
                    if (loconfig !== undefined && loconfig !== null) {
                        if (loconfig.hasOwnProperty("langpref") && loconfig["langpref"] === true) {
                            //if (!lslookupparam.includes('Authentication/')) {
                            let decryptedData = glDecrypt(postresponse.data).toString();
                            if (decryptedData !== null && decryptedData !== "") {
                                try {
                                    decryptedData = JSON.parse(decryptedData);
                                }
                                catch (error) {
                                }
                            }
                            postresponse.data = decryptedData;
                            //}
                        }
                    }
                }
                loReturnData.status = true;
                loReturnData.data = postresponse.data
                loReturnData.error = "";
                loReturnData.errmsg = ""
                if (postresponse.data !== null && postresponse.data.hasOwnProperty("info")) {
                    loReturnData.info = postresponse.data.info;
                }
                if (postresponse.data !== null && postresponse.data.hasOwnProperty("data")) {
                    loReturnData.data = postresponse.data.data;
                    if (postresponse.data.hasOwnProperty("resultStr")) {
                        loReturnData.resultStr = postresponse.data.resultStr;
                    }
                    if ((postresponse.data.hasOwnProperty("errCode") === true || postresponse.data.data === 1 || postresponse.data.data === 2 || postresponse.data.data === 3) && postresponse.data.status === false) {
                        loReturnData.status = false;
                        loReturnData.error = postresponse.data.errorMsg;
                        loReturnData.errmsg = postresponse.data.errorMsg
                        loReturnData.data = postresponse.data.data;
                        if (postresponse.data.hasOwnProperty("errCode")) {
                            loReturnData.errCode = postresponse.data.errCode;
                        }
                    }
                    else if (postresponse.data.data !== null && postresponse.data.status !== false) {
                        if (postresponse.data.data !== null && postresponse.data.data.hasOwnProperty('error')) {
                            if (postresponse.data.data.error !== null) {
                                loReturnData.status = false;
                                loReturnData.error = postresponse.data.data.error
                            }
                        }
                        if (postresponse.data.data !== null && postresponse.data.data.hasOwnProperty('errorMsg')) {
                            if (postresponse.data.data.errorMsg !== null) {
                                loReturnData.status = false;
                                loReturnData.errmsg = postresponse.data.data.errmsg
                            }
                        }
                    }
                    else {
                        loReturnData.status = false;
                        if (postresponse.data.hasOwnProperty('errorMsg')) {
                            loReturnData.error = postresponse.data.errorMsg;
                            loReturnData.errmsg = postresponse.data.errorMsg
                        }
                        else if (postresponse.data.hasOwnProperty('errmsg')) {
                            loReturnData.error = postresponse.data.errmsg;
                            loReturnData.errmsg = postresponse.data.errmsg
                        }
                        else {
                            loReturnData.error = postresponse.data.error;
                            loReturnData.errmsg = postresponse.data.error
                        }
                        if (loReturnData.data !== undefined && loReturnData.data !== null && loReturnData.data !== "") {
                            if (typeof loReturnData.data === "string" && loReturnData.data.includes("{") && loReturnData.data.includes("}")) {
                                loReturnData.data = JSON.parse(loReturnData.data);
                            }
                        } else {
                            loReturnData.data = [];
                        }
                    }
                }
                else {
                    if (postresponse.data !== null && postresponse.data.hasOwnProperty('error')) {
                        if (postresponse.data.error !== null) {
                            loReturnData.status = false;
                            loReturnData.error = loReturnData.data.error
                        }
                        if (postresponse.data !== null && postresponse.data.hasOwnProperty('errorMsg')) {
                            if (postresponse.data.errorMsg !== null) {
                                loReturnData.status = false;
                                loReturnData.errmsg = postresponse.data.errmsg
                            }
                        }
                    }
                }
            }
            else {
                loReturnData.status = false;
                loReturnData.error = "";
                loReturnData.errmsg = postresponse.data.errorMsg
                if (loReturnData.data !== undefined && loReturnData.data !== null && loReturnData.data !== "") {
                    if (typeof loReturnData.data === "string" && loReturnData.data.includes("{") && loReturnData.data.includes("}")) {
                        loReturnData.data = JSON.parse(loReturnData.data);
                    }
                } else {
                    loReturnData.data = [];
                }
            }

            if (loReturnData.data !== null && typeof loReturnData.data !== "object") {
                try {
                    loReturnData.data = JSON.parse(loReturnData.data);
                }
                catch (error) {
                }
            }
            return loReturnData
    /*             .catch((error) => {
                CallConfirmDialog('warning', "Post Operation Failed... \n" + error.response.data)
                loReturnData.data=[];
                loReturnData.status=false;
                loReturnData.error = error.response.data
                if (error.response.data.hasOwnProperty('errorMsg')) {
                    loReturnData.errmsg = error.response.data.errmsg;
                }
                return loReturnData
            })
    */    }
        else {
            if (lbSkpDS === true) {
                loHeader.skpencypt = true;
                loHeader.skpdecypt = true;
            } else {
                let loconfig = glbGetLocalStorage("config");
                if (loconfig !== undefined && loconfig !== null) {
                    if (loconfig.hasOwnProperty("langpref") && loconfig["langpref"] === true) {
                        if (lslookupparam.includes('[') || lslookupparam.includes('{')) {
                            loHeader.skpencypt = true;
                        } else {
                            //if (!lslookupparam.includes('Authentication/')) {
                            let url = lslookupparam.split('?')[0];
                            let params = lslookupparam.split('?')[1];
                            let encryptedParams = glEncrypt(params).toString();
                            lslookupparam = url + '?' + encryptedParams
                            //}
                        }
                    } else {
                        loHeader.skpencypt = true;
                        loHeader.skpdecypt = true;
                    }
                }
            }

            if (lbSCache === true) {
                loHeader.scache = true;
            }

            if (lsCacheType === "L" || lbRefreshCache === false) {
                let loSessionKey = await glbGetSessionStorage(lslookupparam);
                //Ore049 General Master filter logic changes it's worked only single object type filter 
                if (loSessionKey !== undefined && loSessionKey !== null && loSessionKey !== "") {
                    try {
                        if (typeof lsDataSource === 'object' && lsDataSource.hasOwnProperty('type') && lsDataSource.type === 'GM') {
                            if (lsDataSource.hasOwnProperty('filter') && typeof lsDataSource.filter === 'string' && lsDataSource.filter !== '') {
                                let lofil = JSON.parse(lsDataSource.filter);

                                if (lofil.hasOwnProperty('operator') && lofil.hasOwnProperty('field')) {
                                    if (lofil['operator'].toLowerCase() === 'notin' && lofil['value'] !== '') {
                                        let lofld = lofil['field'];
                                        let lasplitvalue = lofil['value'].split(',')
                                        loSessionKey = loSessionKey.filter((o) => lasplitvalue.includes(String(o[lofld])) === false);

                                    }
                                    else if (lofil['operator'].toLowerCase() === "in" && lofil['value'] !== '') {
                                        let lofld = lofil['field'];
                                        let lasplitvalue = lofil['value'].split(',')
                                        loSessionKey = loSessionKey.filter((o) => lasplitvalue.includes(String(o[lofld])) === true);
                                    }
                                }
                            }
                        }
                    }
                    catch (err) {
                        console.log('GM master issues : ' + String(err))
                    }
                    //---------
                    if (typeof loSessionKey === "object") {
                        loReturnData.status = true;
                        loReturnData.data = loSessionKey;
                        loReturnData.errmsg = "";
                        return loReturnData;
                    }
                }
            }
            lslookupparam = lslookupparam.replaceAll('\\\\', '"');
            if (props.lookup === "dpcrud/GetDocumentNo") {
                console.log("doc gen", lslookupparam);
            }
            /*let lotimedetails = {};
            console.log("start lookup details", JSON.stringify(props.params), props.datasource);
            lotimedetails.starttime = new Date();
            console.log("start time", lotimedetails.starttime.getHours() + ":" + lotimedetails.starttime.getMinutes() + ":" + lotimedetails.starttime.getSeconds() + ":" + lotimedetails.starttime.getMilliseconds() + "");
            const getresponse = await axios.get(lsGatewayURL + lsRedirectURL + lslookupparam, { headers: loHeader, timeout: 900000 })
            console.log("end lookup details", JSON.stringify(props.params), props.datasource);
            lotimedetails.endtime = new Date();
            console.log("end time", lotimedetails.endtime.getHours() + ":" + lotimedetails.endtime.getMinutes() + ":" + lotimedetails.endtime.getSeconds() + ":" + lotimedetails.endtime.getMilliseconds() + "");
            lotimedetails.seconds = (lotimedetails.endtime.getTime() - lotimedetails.starttime.getTime()) / 1000;
            console.log("total seconds", lotimedetails.seconds);*/
            const getresponse = await axios.get(lsGatewayURL + lsRedirectURL + lslookupparam, { headers: loHeader, timeout: 900000 })
            if (getresponse.status === 200) {

                if (lbSkpDS === false) {
                    let loconfig = glbGetLocalStorage("config");
                    if (loconfig !== undefined && loconfig !== null) {
                        if (loconfig.hasOwnProperty("langpref") && loconfig["langpref"] === true) {
                            //if (!lslookupparam.includes('Authentication/')) {
                            let decryptedData = glDecrypt(getresponse.data).toString();
                            if (decryptedData !== null && decryptedData !== "") {
                                try {
                                    decryptedData = JSON.parse(decryptedData);
                                }
                                catch (error) {
                                }
                            }
                            getresponse.data = decryptedData;
                            //}
                        }
                    }
                }

                loReturnData.status = true;
                loReturnData.data = getresponse.data
                loReturnData.error = "";
                loReturnData.errmsg = ""
                if (getresponse.data !== null && getresponse.data.hasOwnProperty("data")) {
                    loReturnData.data = getresponse.data.data
                    if ((getresponse.data.data === 1 || getresponse.data.data === 2 || getresponse.data.data === 3) && getresponse.data.status === false) {
                        loReturnData.status = false;
                        loReturnData.error = getresponse.data.errorMsg;
                        loReturnData.errmsg = getresponse.data.errorMsg
                        loReturnData.data = getresponse.data.data;
                    }
                    else if (getresponse.data.data !== null && getresponse.data.status !== false) {
                        if (getresponse.data.data.hasOwnProperty('error')) {
                            loReturnData.error = getresponse.data.data.error;
                        }
                        if (getresponse.data.data.hasOwnProperty('errorMsg')) {
                            loReturnData.errmsg = getresponse.data.data.errorMsg;
                        }
                    }
                    else {
                        loReturnData.status = false;
                        loReturnData.errmsg = getresponse.data.error;
                        loReturnData.data = [];
                    }
                }
                else {
                    if (getresponse.data !== null && getresponse.data.hasOwnProperty('error')) {
                        loReturnData.error = getresponse.data.error;
                    }
                    if (getresponse.data !== null && getresponse.data.hasOwnProperty('errorMsg')) {
                        loReturnData.errmsg = getresponse.data.errorMsg;
                    }
                }

            }
            else {
                loReturnData.status = false;
                loReturnData.data = [];
                loReturnData.errmsg = getresponse.data.errorMsg
            }
            try {
                if (loReturnData.data !== null && typeof loReturnData.data !== "object") {
                    try {
                        loReturnData.data = JSON.parse(loReturnData.data);
                    }
                    catch (error) {
                    }
                }
            }
            catch (e) {
            }
            if (loReturnData.status === false && (loReturnData.data === 2 || loReturnData.data === 3)) {
                console.log("logout issue");
                CallConfirmDialog("info", "Session Expired!!! Redirecting to Login Page...");
                console.log("Refresh Token " + lsRefreshToken);
                console.log("Access Token " + lsAccessToken);
                console.log("Params " + lslookupparam);
                lologoutmsg = { cdt: lscurrentdate, edt: new Date(lsexpires), msg: "Session Expired", data: loReturnData.data };
                if (lologoutmsg.data === 3) {
                    lologoutmsg.status = loReturnData.status;
                    lologoutmsg.data = loReturnData.errmsg;
                }
                lologoutmsg = JSON.stringify(lologoutmsg);
                // let currenthref = ReactSession.get("currenthref");
                // window.open(currenthref + "logout?q=" + lologoutmsg, "_self");
                await fnlShowLogoutInfo(lologoutmsg);
            }
            if (loReturnData.status === true && (lsCacheType === "L" || lbRefreshCache === false)) {
                await glbSetSessionStorage(lslookupparam, loReturnData.data)
            }
            try {
                let loUserconfig = glbGetLocalStorage('ssUserConfig');
                if (loUserconfig !== undefined && loUserconfig !== null && loUserconfig !== "") {
                    let lstext = [];
                    if (loReturnData.data.length > 0) {
                        lstext = Object.keys(loReturnData.data[0]).filter(e => {
                            let str = e.toLowerCase()
                            if (loUserconfig.defvalues.language !== null && loUserconfig.defvalues.language !== undefined && loUserconfig.defvalues.language !== "" && str.match(loUserconfig.defvalues.language.toLowerCase() + "_")) {
                                return e
                            }
                        })
                    }
                    if (loReturnData.data.length > 0) {
                        if (lstext.length > 0) {
                            loReturnData.data.map(function (r) {
                                r["en_" + lstext[0].split(loUserconfig.defvalues.language + "_")[1]] = r[lstext[0].split(loUserconfig.defvalues.language + "_")[1]];
                                r[lstext[0].split(loUserconfig.defvalues.language + "_")[1]] = r[lstext[0]];
                                r["labelfld"] = lstext[0].split(loUserconfig.defvalues.language + "_")[1];
                                return r;
                            });
                        }
                        else {
                            if (loUserconfig.defvalues.language === "en") {
                                let lsssUserData = glbGetLocalStorage("ssUserData");
                                let loaddinfo = JSON.parse(lsssUserData.addinfo);
                                if (typeof loaddinfo.applang === "string" && loaddinfo.applang !== "") {
                                    let lssplitapplang = loaddinfo.applang.split(",");
                                    for (let i = 0; i < lssplitapplang.length; i++) {
                                        lstext = Object.keys(loReturnData.data[0]).filter(e => {
                                            let str = e.toLowerCase()
                                            if (str.match(lssplitapplang[i].toLowerCase() + "_")) {
                                                return e
                                            }
                                        })
                                        if (lstext.length > 0) {
                                            if (loReturnData.data[0].hasOwnProperty("en_" + lstext[0].split(lssplitapplang[i].toLowerCase())) === false) {
                                                loReturnData.data.map(function (r) {
                                                    r["en_" + lstext[0].split(lssplitapplang[i].toLowerCase() + "_")[1]] = r[lstext[0].split(lssplitapplang[i].toLowerCase() + "_")[1]];
                                                    r["labelfld"] = lstext[0].split(lssplitapplang[i].toLowerCase() + "_")[1];
                                                    return r;
                                                });
                                                break;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            catch (err) {
                return loReturnData;
            }
            return loReturnData;
        }


    }

    catch (error) {
        // window.alert(error); 
        let networkerror = false;
        if (error.hasOwnProperty("code") === true && (error.code === 'ERR_NETWORK' || error.code === '"ECONNABORTED"')) {
            let popups = document.getElementsByClassName('alertDialoge').length;
            if (popups === 0) {
                //setLoading(false);
                networkerror = true;
                CallConfirmDialog("warning", "Network Error");
            }
        }
        //console.error(error); // You might send an exception to your error tracker like AppSignal
        if (error.hasOwnProperty("response") === true && (error.response.status === 401 || (error.response.hasOwnProperty("data") === true && (error.response.data === "Session Expired" || (typeof error.response.data === "string" && (error.response.data.includes("Session expired") || error.response.data.includes("Token Expired"))))))) {
            console.log("Refresh Token" + lsRefreshToken);
            console.log("Access Token" + lsAccessToken);
            console.log("Params" + lslookupparam);
            lologoutmsg = JSON.stringify({ cdt: lscurrentdate, edt: new Date(lsexpires), msg: "Session Expired", status: error.response.status, data: error.response.data });
            // let currenthref = ReactSession.get("currenthref");
            // window.open(currenthref + "logout?q=" + lomsg, "_self");
            await fnlShowLogoutInfo(lologoutmsg);
        }
        let lsStatus;
        if (error !== undefined) {
            lsStatus = error.code === "ERR_BAD_REQUEST" || error.code === "err_bad_request" || networkerror === true ? false : true;//Direct Query issue so bad request checking
        } else {
            lsStatus = false;
        }
        const loreturn = { status: lsStatus, data: [], error: error, errmsg: networkerror === true ? null : error.message }
        return loreturn;
    }

}
async function fnlShowLogoutInfo(lologoutmsg) {
    if (glbGetLocalStorage("logoutissue")) {
        if (window.location.pathname.includes("/logout")) {
            return;
        }
        glbSetLocalStorage("islogout", true);
    }
    setisLoading(false);
    let lsqrystr = JSON.parse(lologoutmsg);
    let lomsgarray = [];
    lomsgarray.push("Current Date - " + new Date(lsqrystr.cdt).getDate() + "/" + parseInt(new Date(lsqrystr.cdt).getMonth() + 1) + "/" + new Date(lsqrystr.cdt).getFullYear() + " " + new Date(lsqrystr.cdt).toLocaleTimeString());
    lomsgarray.push("Expiry Date - " + new Date(lsqrystr.edt).getDate() + "/" + parseInt(new Date(lsqrystr.edt).getMonth() + 1) + "/" + new Date(lsqrystr.edt).getFullYear() + " " + new Date(lsqrystr.edt).toLocaleTimeString());
    lomsgarray.push("Message - " + lsqrystr.msg);
    lomsgarray.push("Description - " + lsqrystr.data);
    lomsgarray.push("Status - " + lsqrystr.status);
    lomsgarray.push("");
    lomsgarray.push("Redirecting to login page!");
    await CallConfirmDialog("info", lomsgarray, await fnlConfirmLogout);
}
async function fnlConfirmLogout() {
    let lbzissterapp = glbGetLocalStorage("zissterapp");
    let currenthref = window.location.origin;
    if (typeof lbzissterapp === "string" && lbzissterapp !== "") {
        window.open(currenthref + process.env.PUBLIC_URL + "/logout", "_self");
    }
    else {
        window.open(currenthref + "/logout", "_self");
    }
}
function fnFormatHTTPResponse(psDataArray) {
    try {
        return JSON.stringify(psDataArray, null, 2)
    }
    catch (err) {
        console.log("Error Occurred" + err)
        return
    }
};
export default CallApi;